export const fieldStyles =
  "flex flex-col gap-2 mx-4 my-0 mb-6 last:mb-4 min-w-[30rem]";

export const buttonGroupStyles =
  "flex justify-end py-4 mt-4 pr-8 border-t border-neutral-100";

export const labelStyles = "font-semibold";

export const inputStyles =
  "rounded bg-white px-3 py-5 outline-none w-[30rem] max-w-full border border-neutral-200";
